import React from "react";
import { array, bool } from "prop-types";
import styles from "./styles/InstructorSlider.module.css";
import { NextArrow, PrevArrow } from "@components/common";
import Slider from "react-slick";
import {
  InstructorCard,
  InstructorCardPlaceholder,
} from "@components/InstructorCard";

const InstructorSlider = ({ data, loading }) => {
  // state

  // variables
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };

  // logics before hooks

  // hooks

  // logics
  const instructorsPlaceholderData = Array.from(Array(5).keys());

  const coursesData = data ?? [];

  // UI partials
  const instructorsPlaceholder = instructorsPlaceholderData.map((key) => (
    <InstructorCardPlaceholder key={key} />
  ));

  const instructors = coursesData.map((item, index) => (
    <InstructorCard key={index} data={item} />
  ));

  // UI partials

  // effects

  // render
  return (
    <Slider {...settings} className={styles.slider}>
      {loading ? instructorsPlaceholder : instructors}
    </Slider>
  );
};

/* required: display name */
InstructorSlider.displayName = "InstructorSlider";

/* required: props types */
InstructorSlider.propTypes = { data: array, loading: bool };

/* required: default props */
InstructorSlider.defaultProps = { data: [], loading: true };

export { InstructorSlider };
